import React from 'react';
import {ReactComponent as Check} from './check.svg';

const List = ({stories, onRemoveItem, onHighlight, highlightedStories, onRemoveHighlight}) => 
    stories.map(item => 
    <Item key={item.objectID} item={item} onRemoveItem={onRemoveItem} 
    onHighlight={onHighlight} highlightedStories={highlightedStories} onRemoveHighlight={onRemoveHighlight}/>);

  const Item = ({item, onRemoveItem, onHighlight, highlightedStories, backgroundColor, onRemoveHighlight}) => {
    backgroundColor = (highlightedStories.includes(item.objectID)) ? 'yellow' : 'white';    
    
       return(

        <div className="item" style={{backgroundColor: backgroundColor}}>
        <h2>{item.title}</h2>
        <h3><a href={item.url} target="_blank" rel="noreferrer">Click here to read</a></h3>
        <p>Written by {item.author} in {item.created_at.slice(0,4)}</p>
        <div className="buttonflex">
        <button type='button' onClick={() => {onRemoveItem(item)}}>Remove Story</button>
        {backgroundColor==='white' && <button type='button' className="standout" onClick={() => {onHighlight(item.objectID)}}>Want to Read <Check height="18px" width="18px"/></button>}
        {backgroundColor==='yellow' && <button type='button' className="highlightbutton" onClick={() => {onRemoveHighlight(item.objectID)}}>Remove Highlight</button>}
        </div>
        </div>
        
  ) ;
}    

export default List
